import { render, staticRenderFns } from "./MyFavoriteCragsCarousel.vue?vue&type=template&id=4675af06"
import script from "./MyFavoriteCragsCarousel.vue?vue&type=script&lang=js"
export * from "./MyFavoriteCragsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports